import { FC, memo } from 'react';
import { Tooltip, Stack } from '@mui/material';
import { CloudCircle, Stars } from '@mui/icons-material';

import { TagsSelect } from '/shared/Tags/PolicyTags/TagsSelect';

import { IntelliTagPickerProps } from './types';
import { tagColor } from './helpers';
import { IconWrapper, Container } from './styles';

export const IntelliTagsPicker: FC<IntelliTagPickerProps> = memo(
  ({ requiredTags, creationTags, otherTags, addCustomValue, handleSelectTag, className, tags, isMeta }) => {
    const isPolicyTagSelected = (key: string) => !!tags?.find((tag) => tag.key === key);
    const showBlock = requiredTags.length > 0 || creationTags.length > 0 || otherTags.length > 0;
    return (
      <Container $showBlock={showBlock} spacing={1} className={className}>
        {(!!requiredTags.length || !!creationTags.length) && (
          <Stack direction='row' spacing={1}>
            <Tooltip title='Suggested' placement='top'>
              <IconWrapper>
                <Stars sx={{ color: tagColor.require.icon }} />
              </IconWrapper>
            </Tooltip>
            <Stack direction='row' spacing={1} flexWrap='wrap' id='scroll-wrapper'>
              {requiredTags.map((tag) => (
                <TagsSelect
                  key={tag.key}
                  onSelect={handleSelectTag}
                  tag={tag}
                  selected={isPolicyTagSelected(tag.key)}
                  mainColor={tagColor.require}
                  addCustomValue={addCustomValue}
                />
              ))}
              {creationTags.map((tag) => (
                <TagsSelect
                  key={tag.key}
                  onSelect={handleSelectTag}
                  tag={tag}
                  selected={isPolicyTagSelected(tag.key)}
                  mainColor={tagColor.creation}
                />
              ))}
            </Stack>
          </Stack>
        )}
        {!!otherTags.length && (
          <Stack direction='row' spacing={1}>
            {!isMeta ? (
              <Tooltip title='Additional Tags' placement='top'>
                <IconWrapper>
                  <CloudCircle sx={{ color: tagColor.other.icon }} />
                </IconWrapper>
              </Tooltip>
            ) : null}
            <Stack direction='row' flexWrap='wrap' justifyContent='flex-start' gap='8px' id='scroll-wrapper'>
              {otherTags.map((tag) => (
                <TagsSelect
                  key={tag.key}
                  onSelect={handleSelectTag}
                  tag={tag}
                  selected={isPolicyTagSelected(tag.key)}
                  mainColor={tagColor[isMeta ? 'isMeta' : 'other']}
                  isSelectable
                  addCustomValue={addCustomValue}
                />
              ))}
            </Stack>
          </Stack>
        )}
      </Container>
    );
  }
);
